import { render, staticRenderFns } from "./CourseCreate.vue?vue&type=template&id=3440a69e"
import script from "../../../controllers/custom/course/course-create.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/course/course-create.js?vue&type=script&lang=js&external"
import style0 from "./CourseCreate.vue?vue&type=style&index=0&id=3440a69e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports